import { useCallback, useState } from 'react';

interface PaginationState {
  cursors: ( string | null )[];
  currentCursorIdx: number;
}

export function useCursorPagination() {
  const [ { cursors, currentCursorIdx }, setState ] = useState<PaginationState>( {
    cursors: [ null ],
    currentCursorIdx: 0
  } );

  const currentCursor = cursors[ currentCursorIdx ] ?? null;
  const currentPage = currentCursorIdx + 1;
  const canGoPrev = currentCursorIdx > 0;

  const goNext = useCallback( ( nextCursor: string ) => {
    setState( prev => ( {
      cursors: [ ...prev.cursors.slice( 0, prev.currentCursorIdx + 1 ), nextCursor ],
      currentCursorIdx: prev.currentCursorIdx + 1
    } ) );
  }, [] );

  const goPrev = useCallback( () => {
    setState( prev => ( {
      ...prev,
      currentCursorIdx: Math.max( 0, prev.currentCursorIdx - 1 )
    } ) );
  }, [] );

  const reset = useCallback( () => {
    setState( { cursors: [ null ], currentCursorIdx: 0 } );
  }, [] );

  return { cursors, currentCursorIdx, currentCursor, currentPage, canGoPrev, goNext, goPrev, reset };
}
